import React from 'react'
import {Navbar, Nav} from 'react-bootstrap';
import '../styles/nav.css';

export class NavigationHeader extends React.Component { 
    
    render(){  

        return (

            <div className="nav_wrapper page_content">
                <div className="temp_message">
                <Nav.Link href="https://sacoronavirus.co.za/" target="_blank">South African Government's COVID-19 Information Page at sacoronavirus.co.za.</Nav.Link>
                            
                </div>
            
                <Navbar className="nav_container"  bg="light" expand="lg">
                    <div className="nav_logo">
                        <Navbar.Brand href="/"><img src="../../assets/logo_no_bg.png" alt="logo"/> </Navbar.Brand>
                        
                    </div>
                    <div className="company_name"><span>Smart Khalanga Solutions</span></div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            <Nav.Link href="/home" ref={this.homeRef} id="home">Home</Nav.Link>
                            <Nav.Link href="/about" ref={this.aboutRef}>About</Nav.Link>
                            <Nav.Link className="service_menu" href="/services">Services
                                <div className="services_submenu">
                                    <Nav.Link href="/services/network-and-infrastructure">Network and Infrastructure</Nav.Link>
                                    <Nav.Link href="/services/sourcing-and-supply-chain">Sourcing and Supply Chain</Nav.Link>
                                    <Nav.Link href="/services/client-computing-management">Client Computing Management</Nav.Link>
                                    <Nav.Link href="/services/server-infrastructure-implementation">Server Infrastructure Implementation</Nav.Link>
                                    <Nav.Link href="/services/website-email-services">Website and Email Services</Nav.Link>
                                    <Nav.Link href="/services/service-desk-management">Service Desk Management</Nav.Link>
                                </div>
                            </Nav.Link>
                            <Nav.Link href="/contact-us">Contact Us</Nav.Link>  
                        </Nav>
                        
                    </Navbar.Collapse>
                </Navbar>            
            </div>        
        )
    }
}